import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";
import { loadOneAxis, patchOneAxis } from "../axis/one-axis/oneAxisAction";
import { useDispatch, useSelector } from "react-redux";
import { patchOneSwotItem } from "./one-swot-item/SwotItemAction";
import { CLEAR_SWOT_ITEM } from "./one-swot-item/actionTypes";
import {
  loadProject,
  patchProject,
} from "../project/one-project/projectAction";
import { loadStrategy, patchStrategy } from "../strategy/strategyAction";

const TextAreaCard = ({
  setFormOpen,
  type = null,
  content,
  id = 0,
  entity,
}) => {
  const placeholder = "Ajouter une carte";
  const dispatch = useDispatch();
  const { id: axisId } = useSelector((state) => state.oneAxis);
  const { id: projectId } = useSelector((state) => state.project);
  const { id: strategyId } = useSelector((state) => state.strategy);

  const cardRef = useRef();

  const closeForm = () => {
    setFormOpen(false);
  };
  const [text, setText] = useState(content || "");

  useEffect(() => {
    return () => {
      setText("");
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text === "") {
      closeForm();
      return;
    }
    let data = {};
    data.type = type;
    data.content = text;
    let swot = { swots: [] };
    swot.swots.push(data);

    if (entity === "axis") {
      dispatch(patchOneAxis(axisId, swot));
      setTimeout(() => {
        dispatch({ type: CLEAR_SWOT_ITEM });
      }, 1000);
    }
    if (entity === "project") {
      dispatch(patchProject(projectId, swot));
    }
    if (entity === "strategy") {
      dispatch(patchStrategy(strategyId, swot));
    }
    setFormOpen(false);

    closeForm();
    setText("");
  };

  const handleSubmitForExistingItem = async (e) => {
    e.preventDefault();
    if (text === "") {
      closeForm();
      return;
    }
    let data = {};
    data.content = text;
    await dispatch(patchOneSwotItem(id, data));
    setFormOpen(false);
    setText("");
    if (entity === "axis") {
      dispatch(loadOneAxis(axisId));
    }
    if (entity === "project") {
      dispatch(loadProject(projectId));
    }
    if (entity === "strategy") {
      dispatch(loadStrategy());
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setText(value);
  };

  const onEnterPress = async (e) => {
    if (e.key === "Escape") {
      closeForm();
    }
    if (e.key === "Enter" && !e.shiftKey) {
      if (text.trim() === "") {
        closeForm();
        return;
      }
      if (id !== 0) {
        await handleSubmitForExistingItem(e);
      } else {
        handleSubmit(e);
      }
    }
  };

  return (
    <Form
      ref={cardRef}
      onSubmit={id !== 0 ? handleSubmitForExistingItem : handleSubmit}
      onKeyDown={onEnterPress}
    >
      <TextArea
        maxLength={300}
        placeholder={placeholder}
        onBlur={id !== 0 ? handleSubmitForExistingItem : handleSubmit}
        autoFocus={true}
        value={text}
        onChange={handleChange}
      />
    </Form>
  );
};

const TextArea = styled(TextareaAutosize)`
  background-color: var(--color-white);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  min-height: 20px;
  padding: 0.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  min-width: 100%;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default TextAreaCard;
